import auth from "../store/modules/auth";
import chat from "../store/modules/chat";
import { log2 } from "../utils/log2";
import { filter, map, switchMap } from "rxjs/operators";
import { from, interval } from "rxjs";
import { systemMessageStream } from "../utils/systemPubSub";
import _ from "lodash";
import store from "../store";

const log = log2("titleUpdater");
const getAlias = () => {
    const site = store.state.site.site;
    return site?.alias || "";
};
const getMyConversations = () =>
    auth.state.user
        ? chat.state.conversations
              .map((x) => {
                  x.meta = chat.state.conversationsMeta[x._id] || { unread: 0, active: false };
                  return x;
              })
              .filter((c) => c.meta.active === true && c.users.includes(auth.state.user._id))
        : [];

export const startTitleUpdater = () => {
    // log("startTitleUpdater called ");
    systemMessageStream
        .pipe(
            filter((x) => x.type === "tab_visibility_change"),
            // tap((x) => log("after operator 1 ", x)),
            map((x) => x.payload.visible),
            // tap((x) => log("after operator 2 ", x)),
            switchMap((x) => (x ? from([x]) : interval(3000).pipe(map((c) => x))))
            // tap((x) => log("after operator 3 ", x))
        )
        .subscribe((tabVisible) => {
            let countUnReadMessages = _.sum(getMyConversations().map((x) => x.meta.unread));
            const alias = getAlias();

            if (!tabVisible && countUnReadMessages > 0) {
                document.title = `(${countUnReadMessages} new message) Supsis - ${alias.charAt(0).toUpperCase() + alias.slice(1)}`;
            } else {
                document.title = `Supsis - ${alias.charAt(0).toUpperCase() + alias.slice(1)}`;
            }
        });
};
